import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  useTranslation,
  TablePopUpContainer,
  TableConnectionPopupsWr,
  PostMessageListenerMessages,
  PlatformMessagesWrapper,
  GameLaunchManager,
  applicationStore,
  popupStore,
  betStore,
  LoadingContainer,
} from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';

import { FactoryRouter } from './factoryRouter';
import { gameLiveConnection } from '../services';
import { HelpPopup } from '../components/helpPopup';
import { autoBetStore } from '../store/autoBetStore';
import { SocketConnection } from './socketConnection';
import { TranslationKeys } from '../enums/translationKeys';
import { FairnessPopup } from '../components/fairnessPopup';
import { CheckHashPopup } from '../components/checkHashPop';
import { socketEventsHandlerDelays } from '../enums/replaySocetEventsDelays';
import { doBetStore } from '../store/doBetStore';
import { gameStore } from '../store/gameStore';
import { AppDefaultValuesEnum } from '../enums/appDefaultValues';

import gameLogo from '../assets/images/logo.svg';
import logoPG from '../assets/images/logo-loading-png.png';
import loadingBg from '../assets/images/main-background.png';

export const Factory = observer(({ components }) => {
  const t = useTranslation();
  const { popupToggle, popupName } = popupStore;

  const popupMap = useMemo(
    () => ({
      [PopUps.Fairness]: {
        component: FairnessPopup,
        title: t(TranslationKeys.Fairness),
      },
      [PopUps.CheckHash]: {
        component: CheckHashPopup,
        title: t(TranslationKeys.Check),
      },
      [PopUps.Reconnect]: {
        component: TableConnectionPopupsWr,
        title: t(TranslationKeys.Reconnect),
      },
      [PopUps.ConnectionError]: {
        component: TableConnectionPopupsWr,
        title: t(TranslationKeys.ConnectionError),
      },
      [PopUps.GameOpen]: {
        component: TableConnectionPopupsWr,
        title: t(TranslationKeys.GameOpen),
      },
      // [PopUps.MobileNavigation]: MobileNavigationPopupWr,
      [PopUps.Help]: {
        component: HelpPopup,
        title: t(TranslationKeys.Help),
      },
    }),
    [t]
  );

  useEffect(() => {
    applicationStore.setIsBogLine(true);
  }, []);

  const memoAdditionalMessagesParams = useMemo(() => {
    return [
      {
        name: PostMessageListenerMessages.UpdateBalance,
        callback: () => gameLiveConnection.getBalance(),
      },
      {
        name: PostMessageListenerMessages.StopAutoSpins,
        callback: () => {
          autoBetStore.resetAutoBet();
        },
      },
    ];
  }, []);

  const repliedCallback = () => {
    const { repliedBetData } = betStore;
    doBetStore.setSelectedAmount(repliedBetData?.amount);
    doBetStore.setSelectedOdd(repliedBetData.odd);
    gameStore.setIsTurboModeExist(true);
  };
  return (
    <LoadingContainer
      appDefaultValuesEnum={AppDefaultValuesEnum}
      gameSpecificRepliedCallback={repliedCallback}
      gameLoadingImages={{ logoPG, bgImage: loadingBg, gameLogo }}
    >
      <PlatformMessagesWrapper
        additionalMessagesParams={memoAdditionalMessagesParams}
        autoPlayOnAndOffState={autoBetStore.isPlay}
      >
        <GameLaunchManager
          isTurbo
          socketEventsHandlerDelays={socketEventsHandlerDelays}
          GameContainer={<FactoryRouter components={components} />}
          SocketConnectionWr={
            <SocketConnection>
              <FactoryRouter components={components} />
            </SocketConnection>
          }
        />
      </PlatformMessagesWrapper>
      {popupToggle && popupName && <TablePopUpContainer popupMap={popupMap} />}
    </LoadingContainer>
  );
});
